let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iMEy4")).then(() => parcelRequire('49B6r'));